import React from 'react'
import Oursectors from '../Components/HomePage/OurSectors/Oursectors'

const SectorPage = () => {
  return (
    <div>
        <Oursectors />
    </div>
  )
}

export default SectorPage